import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {DatasetService} from '../../../provider/dataset.service';
import {DatasetModel} from '../../models/dataset.model';

@Component({
  selector: 'c-analysis',
  templateUrl: './analysis.component.html',
  styleUrls: ['./analysis.component.scss']
})
export class AnalysisComponent implements OnInit, OnChanges {

  constructor(public datasetService: DatasetService) {
  }

  palette: string[] = ['#c3a2cc', '#b7b5e0', '#e48cba'];
  paletteIndex = 0;
  intervals = ['day', 'week', 'month', '3month'];
  interval = 'month';
  query = '';
  data: DatasetModel[];
  title = '';

  @Input() ID: number;
  popupVisible = false;
  customizePoint = () => {
    const color = this.palette[this.paletteIndex];
    this.paletteIndex = this.paletteIndex === 2 ? 0 : this.paletteIndex + 1;

    return {
      color
    };
  };

  ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;
    this.query = '?item=' + this.ID.toString();
    this.datasetService.getData();
    this.datasetService.getDataByItemId(this.ID);
    this.datasetService.getPieChart('month', this.query);
  }

  ngOnInit() {
  }

  onValueChanged(data) {
    console.log(data.value);
    this.datasetService.getDataWithInterval(data.value, '', '', '', this.ID.toString(),'');
    this.datasetService.getPieChart(this.interval, this.query);
    this.interval = data.value;
  }

  onPointClick(e, data, type ?: string) {
    this.title = e.target.originalArgument;
    this.popupVisible = true;
    if (type == 'pie') {
      this.data = data.filter(x => x.item == e.target.originalArgument);
      return;
    } else if (type == 'rating') {
      this.data = data.filter(x => x.date == e.target.originalArgument);
      return;
    }
    this.data = data.filter(x => x.item == e.target.originalArgument);
  }

}
